import { CloseIconButton } from '@library/components/buttons';
import { cn } from '@library/component-utils/cn';

export interface MemberDrawerHeaderProps {
  children?: React.ReactNode;
  className?: string;
  onClose: () => void;
}

export const MemberDrawerHeader = ({
  children = undefined,
  className = '',
  onClose
}: MemberDrawerHeaderProps) => {
  return (
    <div className="border-soFresh-140 flex h-16 items-center border-b px-6 py-2">
      <div className={cn('flex h-full flex-col justify-evenly', className)}>
        {children}
      </div>
      <CloseIconButton handleOnClick={onClose} className="ml-auto" />
    </div>
  );
};
